<template>

    <div>
        <span
            class="category"
            v-if="category"
        >
            {{ category }}
        </span>
        <span class="number">
            <slot></slot>
        </span>
    </div>
</template>

<script>
/**
 * 入力欄の見出し番号のデザイン
 * 
 * [プロパティ]
 * category ... 見出し番号の上に乗る分類名称
 * 
 * [利用例]
 * <parts-arrow category="基本情報">1</parts-arrow>
 */
export default {
    name:"PartsArrow",
    props: {
        /**
         * 見出し番号の上に乗る分類名称
         * 大見出しでは必要だが、見出し文中でほかの入力欄の番号を示す時には不要
         */
        category: {
            type:String,
        }
    },
}
</script>

<style scoped>
.category{
    display: block;
    margin: 0 0 2px;
    padding: 0;
    font-size: 12px;
    line-height: 12px;
}
.number{
    display:inline-block;
    width: 50px;
    min-width: 50px;
    height: 32px;
    margin: 0 4px 0 0;
    padding: 0 0.5em 0 0;
    font-size: 20px;
    font-weight:bolder;
    text-align: center;
    letter-spacing: -0.1em;
    line-height: 32px;
    overflow: hidden;
    color: white;
    background: url(/img/all_icons.png) no-repeat; /* スプライト呼び出し */
    background-size: auto calc( 225 / 65 * 100% );
    background-position-x: 0;
    background-position-y: calc(120 / (225 - 65) * 100%);
}
_:-ms-lang(x)::-ms-backdrop, .number {
    width: 60px;
    background-size: auto 346%;
    padding-top: 4px;
    box-sizing: border-box;
}
.line {
    display: inline-flex;
}

.line .number{
    width: 28px;
    min-width: 28px;
    height: 22px;
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    overflow: hidden;
    color: #41B8D4;
    background-size: auto calc( 225 / 65 * 100% );
    background-position-x: calc(142 / (1725 - 85) * 100%);
    background-position-y: calc(120 / (225 - 65) * 100%);
}

_:-ms-lang(x)::-ms-backdrop, .line .number {
    width: 32px;
    padding-top: 2px;
    box-sizing: border-box;
}
</style>